import React from 'react';
import './EmpowerSection.css';
import empowerImage1 from '../../assets/images/empower-image-1.jpg'; // Updated image import
import empowerImage2 from '../../assets/images/empower-image-2.jpg'; // Updated image import


const EmpowerSection = () => {
  return (
    <section className="empower-section">
      <div className="container">
        {/* Top Content Block */}
        <div className="empower-grid">
          <div className="empower-text-content">
            <p>
              We don’t just implement systems; we empower our clients. Through our comprehensive SAP ERP services, we equip businesses with the tools and capabilities needed to thrive in today’s competitive landscape. Our commitment to training and knowledge transfer sets us apart, ensuring both our team and clients remain at the forefront of SAP technology.
            </p>
            <p>
              Whether deploying new systems or supporting existing ones, we provide our customers with the knowledge, skills, and confidence to effectively manage their SAP infrastructure. At Neuroverse, we’re not just consultants – we’re your partners in growth, innovation, and digital transformation.
            </p>
          </div>
          <div className="empower-images">
           <img
              src={empowerImage1} // Using the specified image
              alt="Team collaboration in office" // You might want to update this alt text based on the actual image content
              className="empower-image-1"
            />
           <img
                 src={empowerImage2} // Using the specified image
              alt="Digital solutions interface" // You might want to update this alt text based on the actual image content
              className="empower-image-2"
            />
          </div>
        </div>

        {/* Vision and Mission Section */}
        <div className="vision-mission-grid">
          <div className="vision-card">
            <h3 className="vm-title">Our Vision</h3>
            <p>To revolutionize industries by unlocking the full potential of AI-driven innovation and human intelligence synergy.</p>
          </div>
          <div className="mission-card">
            <h3 className="vm-title">Our Mission</h3>
            <div className="mission-points">
              <div className="mission-point">
                <h4>Innovation</h4>
                <p>Pioneering creative solutions to shape a smarter and more efficient future.</p>
              </div>
              <div className="mission-point">
                <h4>Collaboration</h4>
                <p>Building strong partnerships to achieve shared goals and drive collective success.</p>
              </div>
              <div className="mission-point">
                <h4>Impact</h4>
                <p>Creating meaningful change that drives growth, sustainability, and lasting value.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default EmpowerSection;
